export const visit = (vm, at) => {
vm(require("./availability/vi.lyaml"));
vm(require("./typical-response-time/vi.lyaml"));
vm(require("./default/vi.lyaml"));
at({ "vi": { "conversations-internal-schema": { "we-wont-use-this-key-in-the-product-but-this-file-wont-update-with-new-languages-without-a-key": "ok" } } });
};